const img = document.querySelectorAll(".js-parallax-image"),
    container = document.querySelectorAll(".js-parallax");

let heightDiff,
    parallaxArray = [],
    parallaxArrayL,
    translateRatio,
    winH = window.innerHeight,
    Parallax = function (parallax) {
        this.container = parallax;
        this.img = parallax.querySelector("img");
        this.currentTop = false;
    };

export function init() {
    container.forEach((el) => {
        parallaxArray.push(new Parallax(el));
    });

    // Count the images
    parallaxArrayL = parallaxArray.length;

    sizeAndUpdate();

    window.addEventListener("scroll", () => {
        if (!window.requestAnimationFrame) {
            return;
        }

        window.requestAnimationFrame(() => {
            updatePositions();
        });
    });

    window.addEventListener("resize", () => {
        winH = window.innerHeight;

        sizeAndUpdate();
    });

    // updateParallaxPositions = function() {
    //   sizeAndUpdate();
    // };
    //   });
}

function getOffset(obj) {
    // Return the offset of this object's container
    return obj.container.offsetTop;
}

function setOffsets() {
    // Update the offsets
    for (let i = 0; i < parallaxArrayL; i++) {
        parallaxArray[i].offset = getOffset(parallaxArray[i]);
    }
}

function parallaxSizing() {
    // Update the heights
    let imgBounding = img[0].getBoundingClientRect(),
        imgH = imgBounding.height,
        containerBounding = container[0].getBoundingClientRect(),
        containerH = containerBounding.height;

    heightDiff = imgH - containerH;

    setOffsets();

    // Update the translate ratio
    translateRatio = heightDiff / (winH + containerH);
}

function doTranslate(img, top) {
    img.style.transform = "translate3d(0," + top + "px,0)";
}

function updatePositions() {
    let winScrollT = window.scrollY,
        top;

    // For each parallax image
    for (let i = 0; i < parallaxArrayL; i++) {
        // Top is the ratio times by distance scrolled with the image in view.
        top = Math.round(
            translateRatio * (winH + winScrollT - parallaxArray[i].offset)
        );

        // Check we are not below zero or above difference
        top = Math.min(Math.max(top, 0), heightDiff);

        // Flip it as we need it to be negatively applied
        top = -top;

        // If the top is not as is currently set, do the translate
        if (top !== parallaxArray[i].currentTop) {
            doTranslate(parallaxArray[i].img, top);

            // Update the top value
            parallaxArray[i].currentTop = top;
        }
    }
}

function sizeAndUpdate() {
    parallaxSizing();

    updatePositions();
}
